export default {
  brand: {
    fileShare: 'Dateifreigabe'
  },
  common: {
    loading: 'Wird geladen...',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    download: 'Herunterladen',
    downloadAll: 'Alle herunterladen',
    downloadSelected: 'Ausgewählte herunterladen',
    selectAll: 'Alle auswählen',
    deselectAll: 'Auswahl aufheben',
    rootDirectory: 'Stammverzeichnis',
    createTime: 'Erstellt am',
    expireTime: 'Läuft ab am',
    totalSize: 'Gesamtgröße',
    noFiles: 'Keine Dateien'
  },
  share: {
    expired: 'Die freigegebenen Dateien sind abgelaufen',
    invalidLink: 'Ungültiger Freigabelink',
    needVerifyCode: 'Bitte geben Sie den Extraktionscode ein',
    verifyCodeLabel: 'Code',
    verifyCodePlaceholder: 'Extraktionscode eingeben',
    extractFiles: 'Dateien extrahieren',
    extractionCodeError: 'Falscher Extraktionscode',
    uuidRequestFailed: 'Download-Anfrage fehlgeschlagen',
    selectFilesFirst: 'Bitte wählen Sie zuerst Dateien aus',
    unknownError: 'Unbekannter Fehler'
  },
  error: {
    networkError: 'Netzwerkfehler',
    connectionFailed: 'Verbindung zum Freigabegerät nicht möglich. Das Gerät ist möglicherweise ausgeschaltet, im Ruhezustand oder die Service-Region wurde geändert. Bitte kontaktieren Sie den Freigebenden.',
    outdatedLink: 'Verbindung zum Freigabegerät nicht möglich. Möglicherweise wurde ein veralteter Freigabelink verwendet. Bitte bitten Sie den Freigebenden, das System auf v2.0.10 oder höher und die APP auf v2.1.5 oder höher zu aktualisieren und den Freigabelink erneut zu kopieren.',
    registryError: 'Fehler beim Abrufen der öffentlichen Netzwerk-Penetrationseinstellungen. Verbindung zum Registry-Dienst nicht möglich.',
    missingRegion: 'Dem Freigabelink fehlen Service-Region-Informationen. Bitte bitten Sie den Freigebenden, das System auf v2.0.10 oder höher und die APP auf v2.1.5 oder höher zu aktualisieren und den Freigabelink erneut zu kopieren.'
  }
}
